import React from "react"
import {formatTextTestIds} from "@next/utils"
import NavIcon from "../../../NavIcon"
import {IconContainer as NavIconContainer} from "../../../CatalogueItem/component"
import {
    Container,
    StyledBtn,
    StyledA,
    TextContainer,
    Text,
    IconContainer,
    Icon,
    LinkContainer,
    DescriptionText,
} from "../../../BurgerQuickLinksContainer/components"
import urls from "../../../../config/urls"
import {QUICKLINK_TYPE, LTR, BURGER_QUICKLINK_TYPE} from "../../../../config/constants"
import FavouritesBadge from "../../../FavouritesBadge"
import configRelativePathURL from "../../../../utils/configUrlPath"

type LinkProps = {
    href?: string
    iconSrc: string | null
    iconAltText: string
    iconFixedHeight?: number
    iconFixedWidth?: number
    title: string | null
    description?: string
    chevronIconAltText: string
    textAlignment: string
    type: string
    linkType: string
    hideBadge?: boolean
    handleClick?: () => void
    siteUrl: string
    realm: string
    variant: string
    iconsVersionPath: string
    maskTitle?: boolean
    dataTestid?: string
}

export type QuickLinkProps = {
    children: NonNullable<React.ReactNode>
    href?: string
    type: string
    testid?: string
    handleClick?: () => void
    siteUrl: string
}

const QuickLink = ({children, href, type, testid, handleClick, siteUrl}: QuickLinkProps) => {
    switch (type) {
        case QUICKLINK_TYPE.BUTTON:
            return (
                <StyledBtn data-testid={testid} type="button" onClick={handleClick}>
                    {children}
                </StyledBtn>
            )

        case QUICKLINK_TYPE.LINK:
            return (
                <StyledA data-testid={testid} href={configRelativePathURL(href || "", siteUrl)}>
                    {children}
                </StyledA>
            )
        default:
            return null
    }
}
const getIcon = (
    type: string,
    alterText: string,
    hideBadge: boolean,
    iconUrl: string,
    iconFixedHeight: number | undefined,
    iconFixedWidth: number | undefined,
) => {
    let icon: any
    switch (type) {
        case BURGER_QUICKLINK_TYPE.FAVOURITES:
            icon = <FavouritesBadge altText={alterText} hideBadge={hideBadge} iconUrl={iconUrl} />
            break
        default:
            icon = (
                <Icon
                    src={`${iconUrl}`}
                    alt={alterText || ""}
                    fixedHeight={iconFixedHeight}
                    fixedWidth={iconFixedWidth}
                />
            )
    }

    return icon
}

export const BurgerQuickLink = ({
    href,
    iconSrc,
    iconAltText,
    iconFixedHeight,
    iconFixedWidth,
    title,
    description,
    chevronIconAltText,
    textAlignment,
    type,
    linkType,
    hideBadge,
    handleClick,
    siteUrl,
    realm,
    variant,
    iconsVersionPath,
    maskTitle = false,
    dataTestid,
}: LinkProps) => {
    if (!title || !iconSrc || (!href && !handleClick)) return null

    let hideBadgeLocal = true

    if (typeof hideBadge !== "undefined") hideBadgeLocal = hideBadge

    return (
        <Container>
            <QuickLink
                href={href}
                type={type}
                handleClick={handleClick}
                testid={formatTextTestIds(`header-burger-primary-quicklink-${dataTestid || title}`)}
                siteUrl={siteUrl}
            >
                <LinkContainer>
                    <IconContainer>
                        {getIcon(linkType, iconAltText, hideBadgeLocal, iconSrc, iconFixedHeight, iconFixedWidth)}
                    </IconContainer>
                    <TextContainer>
                        <Text
                            data-testid={`burger-primary-${title}`}
                            variant="subtitle2"
                            data-dtrum-replay-mask={maskTitle ? "" : null}
                        >
                            {title}
                        </Text>
                        {description && (
                            <DescriptionText
                                data-testid={`burger-primary-${dataTestid || title}-description`}
                                variant="body2"
                            >
                                {description}
                            </DescriptionText>
                        )}
                    </TextContainer>
                </LinkContainer>
                <NavIconContainer>
                    <NavIcon
                        imageUrl={urls.burgerMenu.chevronUrl(realm, variant, iconsVersionPath)}
                        altText={chevronIconAltText}
                        width={1.5}
                        rotationDegrees={textAlignment === LTR ? -90 : 90}
                    />
                </NavIconContainer>
            </QuickLink>
        </Container>
    )
}

export default BurgerQuickLink
